let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ghgWF")).then(() => parcelRequire('a0Vta'));